module.exports = __webpack_public_path__ + "static/media/r89.b8a1a834.jpg";